export const GET_PERSONAL_PAYROLL_LIST_CALL = 'GET_PERSONAL_PAYROLL_LIST_CALL';
export const GET_PERSONAL_PAYROLL_LIST_DONE = 'GET_PERSONAL_PAYROLL_LIST_DONE';
export const GET_PERSONAL_PAYROLL_LIST_FAIL = 'GET_PERSONAL_PAYROLL_LIST_FAIL';

export const GET_PERSONAL_PAYROLL_DETAIL_CALL = 'GET_PERSONAL_PAYROLL_DETAIL_CALL';
export const GET_PERSONAL_PAYROLL_DETAIL_DONE = 'GET_PERSONAL_PAYROLL_DETAIL_DONE';
export const GET_PERSONAL_PAYROLL_DETAIL_FAIL = 'GET_PERSONAL_PAYROLL_DETAIL_FAIL';

export const GET_PAYSLIP_DISPLAY_SETTINGS_CALL = 'GET_PAYSLIP_DISPLAY_SETTINGS_CALL';
export const GET_PAYSLIP_DISPLAY_SETTINGS_DONE = 'GET_PAYSLIP_DISPLAY_SETTINGS_DONE';
export const GET_PAYSLIP_DISPLAY_SETTINGS_FAIL = 'GET_PAYSLIP_DISPLAY_SETTINGS_FAIL';

export const GET_PAYROLL_TASK_DISPLAY_SETTINGS_CALL = 'GET_PAYROLL_TASK_DISPLAY_SETTINGS_CALL';
export const GET_PAYROLL_TASK_DISPLAY_SETTINGS_DONE = 'GET_PAYROLL_TASK_DISPLAY_SETTINGS_DONE';
export const GET_PAYROLL_TASK_DISPLAY_SETTINGS_FAIL = 'GET_PAYROLL_TASK_DISPLAY_SETTINGS_FAIL';
